import { useState, useEffect } from "react"


export const GetExchangeRates = () => {
  const [rates, setRates] = useState({})

  useEffect(() => {
    if(
      localStorage.getItem("dateOfCall") === (new Intl.DateTimeFormat('en-CA').format(Date.now()))
      &&
      localStorage.getItem("cachedUsd2rub") > 0
      &&
      localStorage.getItem("cachedUsd2eur") > 0
      ) {
        setRates({usd2rub: parseFloat(localStorage.getItem("cachedUsd2rub")), usd2eur: parseFloat(localStorage.getItem("cachedUsd2eur"))})
    } else {
      // get data from https://exchangerate.host
      fetch(`https://api.exchangerate.host/latest?base=USD&symbols=RUB,EUR`) //&source=cbr = to source data from russian bank
      .then(response => response.json()) // parse JSON from request
      .then(resultData => {
        setRates({usd2rub: resultData.rates.RUB, usd2eur: resultData.rates.EUR});
        localStorage.setItem("dateOfCall", resultData.date)
        localStorage.setItem("cachedUsd2rub", resultData.rates.RUB)
        localStorage.setItem("cachedUsd2eur", resultData.rates.EUR)
      })
    }
  }, [])

  return rates;
}


export const currencyToUsd = ( price, currency, rates=0) => {
  let currentRates = rates;
  let usdPrice; 

  if (currency === "USD") {
      return price;
  } if (currency === "RUB") {
      usdPrice = Math.round(price / currentRates.usd2rub);
  } else {
      usdPrice = Math.round(price / currentRates.usd2eur);
  }

  return usdPrice;
}

export const convertPrice = (price, activeCurrency, targetCurrency, rates) => {
  let newPrice; 
  console.log("price, activeCurrency, targetCurrency, rates", price, activeCurrency, targetCurrency, rates)
  if (targetCurrency === activeCurrency) {
    newPrice = price;
    return newPrice; 
  } if (targetCurrency === "USD") {
    newPrice = currencyToUsd(price, activeCurrency, rates);
  } if (targetCurrency === "EUR" && activeCurrency === "USD") {
    newPrice = Math.round(price * rates.usd2eur);
  } if (targetCurrency === "EUR" && activeCurrency === "RUB") {
    newPrice = Math.round(price * rates.usd2eur / rates.usd2rub)
  } if (targetCurrency === "RUB" && activeCurrency === "USD") {
    newPrice = Math.round(price * rates.usd2rub)
  } if (targetCurrency === "RUB" && activeCurrency === "EUR") {
    newPrice = Math.round(price * rates.usd2rub / rates.usd2eur)
  }
  
  return newPrice;
}